import { render, staticRenderFns } from "./orderAppealDetail.vue?vue&type=template&id=753991d4&scoped=true"
import script from "./orderAppealDetail.vue?vue&type=script&lang=js"
export * from "./orderAppealDetail.vue?vue&type=script&lang=js"
import style0 from "./orderAppealDetail.vue?vue&type=style&index=0&id=753991d4&prod&scoped=true&lang=css"
import style1 from "./orderAppealDetail.vue?vue&type=style&index=1&id=753991d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753991d4",
  null
  
)

export default component.exports